var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2 13.69v5.302a3.249 3.249 0 0 0 3.249 3.249h11.703a3.249 3.249 0 0 0 3.249-3.249V13.69zm14.253 5.398h-3.911a1 1 0 0 1 0-2h3.911a1 1 0 0 1 0 2zM15.006 1.912a.999.999 0 0 1 .451 1.34l-.583 1.176 1.176.584a.999.999 0 1 1-.889 1.791l-2.299-1.141a.745.745 0 0 1-.336-.999l1.141-2.3a.999.999 0 0 1 1.34-.451z",
    fill: "#ee3d8a",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.603 23.241H4.601A3.605 3.605 0 0 1 1 19.64v-7.802a3.605 3.605 0 0 1 3.601-3.601h13.002a3.605 3.605 0 0 1 3.601 3.601v7.802a3.605 3.605 0 0 1-3.601 3.601zM4.601 10.238c-.883 0-1.601.718-1.601 1.601v7.802c0 .882.718 1.601 1.601 1.601h13.002c.883 0 1.601-.718 1.601-1.601v-7.802c0-.882-.718-1.601-1.601-1.601z",
    fill: "#ee3d8a",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.998 12.69h18.204v2H1.998z",
    fill: "#ee3d8a",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 29a12.93 12.93 0 0 1-9.12-3.735 13.026 13.026 0 0 1-2.277-3.007l1.752-.964a11.068 11.068 0 0 0 1.928 2.546 10.94 10.94 0 0 0 7.718 3.161c6.065 0 11-4.935 11-11s-4.935-11-11-11c-1.161 0-2.304.18-3.395.534l-.617-1.902a12.976 12.976 0 0 1 4.012-.631c7.168 0 13 5.832 13 13s-5.832 13-13 13z",
    fill: "#ee3d8a",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefund);
export default __webpack_public_path__ + "static/media/refund .e578a20a146c4eefb307d98bff809d44.svg";
export { ForwardRef as ReactComponent };